import { useEffect, useState } from "react";
import { Loader2, IndianRupee, CheckCircle2, Clock, MinusCircle } from "lucide-react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const inr = (n) => `₹${new Intl.NumberFormat("en-IN").format(Math.round(n || 0))}`;
const PERIODS = [{ v: "all", l: "All Time" }, { v: "month", l: "This Month" }, { v: "quarter", l: "This Quarter" }, { v: "year", l: "This Year" }];

export default function AdminRevenue() {
  const [data, setData] = useState(null);
  const [period, setPeriod] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/admin/revenue", { params: { period } }).then((r) => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [period]);

  const CARDS = [
    { key: "total", label: "Total Revenue", icon: IndianRupee, color: "text-slate-900", bg: "bg-white" },
    { key: "paid", label: "Paid", icon: CheckCircle2, color: "text-emerald-600", bg: "bg-emerald-50" },
    { key: "pending", label: "Pending", icon: Clock, color: "text-amber-600", bg: "bg-amber-50" },
    { key: "waived", label: "Waived", icon: MinusCircle, color: "text-slate-500", bg: "bg-slate-50" },
  ];

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-display text-2xl font-extrabold text-slate-900">Revenue</h1>
          <p className="mt-1 text-slate-500">From fixed post-sale service charges.</p>
        </div>
        <div className="w-44">
          <Select value={period} onValueChange={setPeriod}>
            <SelectTrigger data-testid="revenue-period"><SelectValue /></SelectTrigger>
            <SelectContent>{PERIODS.map((p) => <SelectItem key={p.v} value={p.v}>{p.l}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>

      {loading ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div> : (
        <div className="mt-6 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {CARDS.map((c) => (
            <div key={c.key} data-testid={`revenue-${c.key}`} className={`rounded-xl border border-slate-200 p-5 ${c.bg}`}>
              <c.icon className={`mb-2 ${c.color}`} size={22} />
              <p className={`font-display text-2xl font-extrabold ${c.color}`}>{data ? inr(data[c.key]) : "—"}</p>
              <p className="mt-0.5 text-xs font-semibold uppercase tracking-wider text-slate-400">{c.label}</p>
            </div>
          ))}
        </div>
      )}
      {data && <p className="mt-4 text-sm text-slate-400">{data.count} service charge record(s) in total.</p>}
    </div>
  );
}
